// src/utils/validationUtils.js
export const isValidPhotoUrl = (url) => {
    const validExtensions = /\.(jpg|JPG|png|PNG)$/;
    return validExtensions.test(url);
};

const GUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isValidGuid = (value) => typeof value === "string" && GUID_PATTERN.test(value);
